"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Label_1 = require("./Label");
exports.default = Label_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Label/index.js
// module id = 39
// module chunks = 8